/**
 * @class PackBuilder - Gestion du pack builder
 * @property {NodeList} products - Liste des produits du pack builder
 */
class PackBuilder extends HTMLElement {
  constructor() {
    super();

    this.builderArray = []; // This array belongs to this specific instance.
    this.builderArrayLength = 0;

    const progressBarContainer = document.querySelector("#pack-builder_progress");
    this.progressBarElement = progressBarContainer.querySelector(".pack-builder_progress-bar");
    this.progressMarkerElements = progressBarContainer.querySelectorAll(".pack-builder_progress-marker");
    this.progressStepsElements = progressBarContainer.querySelectorAll(".pack-builder_progress-step");
    const stepsData = progressBarContainer.getAttribute("data-steps");
    const stepsArray = stepsData.split(",");
    this.progressSteps = [];
    for (var i = 0; i < stepsArray.length; i += 2) {
      this.progressSteps.push({
        quantity: parseInt(stepsArray[i]),
        reduction: parseInt(stepsArray[i + 1])
      })
    }

    this.quantity = {
      min: parseInt(this.dataset.minQuantity),
      max: parseInt(this.dataset.maxQuantity),
    };

    this.content = {
      addedToCart: this.dataset.addedToCartContent,
      addToCart: this.dataset.addToCartContent,
      addMoreProducts: this.dataset.addMoreProductsContent,
    };

    this.button = {
      addToCart: this.querySelector('.pack-builder__selection-add-to-cart'),
    };

    this.builder = this.querySelector('.pack-builder__selection-list');
    this.products = this.querySelectorAll('.pack-builder__product');
    this.cartBuilderNotification = this.querySelector('.pack-builder__products-in-pack');

    this.steps = this.querySelectorAll('[id^="Step-"]');
  }

  connectedCallback() {
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.listenEvents();
  }

  listenEvents() {
    const globalThis = this;

    this.products.forEach((product) => {
      const productButton = product.querySelector('.pack-builder__product-atc');

      product.addEventListener('change', this.updateVariant.bind(this, product));
      productButton.addEventListener('click', () => {
        this.addToBuilderArray(product), this.updateTotalSelectionPrice();
      });
    });

    this.button.addToCart.addEventListener('click', this.addToShopifyCart.bind(this));

    document.addEventListener('scroll', function (e) {
      globalThis.toggleShowElementsOnScroll();
    });
  }

  toggleShowElementsOnScroll() {
    if (this.elementInViewport(this.querySelector('.pack-builder__section-wrapper'))) {
      document.querySelector('pack-builder-sticky-bar').classList.remove('hidden');
    } else {
      document.querySelector('pack-builder-sticky-bar').classList.add('hidden');
    }
  }

  elementInViewport(element) {
    var top = element.offsetTop;
    var height = element.offsetHeight;

    while (element.offsetParent) {
      element = element.offsetParent;
      top += element.offsetTop;
    }
    return top < window.scrollY + window.innerHeight && top + height > window.scrollY;
  }

  updateVariant(product) {
    const buttonAddToPack = product.querySelector('.pack-builder__product-atc');
    const selectedOption = product.querySelector('select option:checked');
    const variantPrice = product.querySelector('.pack-builder__product-price');

    buttonAddToPack.dataset.id = selectedOption.dataset.id;
    buttonAddToPack.disabled = false;
    variantPrice.textContent = selectedOption.dataset.price + '€';

    if (selectedOption.dataset.a11y === 'false') {
      buttonAddToPack.disabled = true;
    }
  }

  updateTotalSelectionPrice() {
    const total_price = this.querySelector('.pack-builder__selection-total-price');
    const total_compare_at_price = this.querySelector('.pack-builder__selection-total-compare-at-price');

    let discount_percentage = 0;

    this.steps.forEach((step) => {
      if (parseInt(step.dataset.stepQuantity) <= this.builderArrayLength) {
        discount_percentage = parseInt(step.dataset.discountPercentage);
      }
    });

    let total = 0;

    this.querySelectorAll('.pack-builder__selection-product button').forEach((item) => {
      total += parseFloat(item.dataset.price.replace(/[^0-9,\.]+/g, '').replace(',', '.'));
    });

    const discountFactor = 1 - discount_percentage / 100;

    let updated_total_price = total;
    let updated_total_compare_at_price = total * discountFactor;

    function setPriceContent(element, price) {
      element.innerHTML = price.toFixed(2).replace('.', ',') + ' €';
    }

    setPriceContent(total_price, updated_total_price);

    if (updated_total_compare_at_price > 0 && updated_total_compare_at_price < updated_total_price) {
      total_compare_at_price.classList.remove('hidden');
      total_price.classList.add('override');
      setPriceContent(total_compare_at_price, updated_total_compare_at_price);
    } else {
      total_price.classList.remove('override');
      total_compare_at_price.classList.add('hidden');
      setPriceContent(total_compare_at_price, 0);
    }
  }

  createHTMLListElement(product) {
    const productTitle = product.querySelector('.pack-builder__product-title').textContent;
    const productSelectedVariantSize = product.querySelector('.pack-builder__product option:checked').textContent;
    const productImage = product.querySelector('.pack-builder__product-image img').src;
    const productSelectedVariant = product.querySelector('.pack-builder__product-atc').dataset.id;
    const productPrice = product.querySelector('.pack-builder__product-price').textContent;

    const productHTML = `
        <li class="pack-builder__selection-product">
          <button class="pack-builder__selection-remove" data-id="${productSelectedVariant}" data-price="${productPrice}" onclick="this.disabled=true;this.closest('pack-builder').removeProduct(this);">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
          </button>
          <div class="pack-builder__selection-product-image">
            <img src="${productImage}" alt="${productTitle}">
          </div>
          <span class="pack-builder__selection-product-size">${productTitle} ${productSelectedVariantSize}</span>
        </li>
      `;

    this.builder.insertAdjacentHTML('beforeend', productHTML);
  }

  addToShopifyCart() {
    const formData = {
      items: this.builderArray,
      sections: this.getSectionsToRender().map((section) => section.id),
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        setTimeout(async () => {
          await this.cart.renderContents(response);
        });
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  removeProduct(buttonElement) {
    this.removeFromBuilderArray(buttonElement);
    this.toggleHideProductsButton(true);
    this.cartBuilderNotificationTrigger();
    this.updateTotalSelectionPrice();

    setTimeout(() => {
      this.toggleHideProductsButton(false);
    }, 1000);
  }

  toggleHideProductsButton(hide = false) {
    this.products.forEach((product) => {
      if (hide) {
        const button = product.querySelector('.pack-builder__product-atc');
        button.disabled = true;
      } else {
        const button = product.querySelector('.pack-builder__product-atc');
        button.dataset.available === 'false' ? (button.disabled = true) : (button.disabled = false);
      }
    });
  }

  addToBuilderArray(product) {
    this.toggleHideProductsButton(true);

    const productButton = product.querySelector('.pack-builder__product-atc');
    productButton.innerHTML = this.content.addedToCart;

    const productId = parseInt(productButton.dataset.id);
    const existingProduct = this.builderArray.find((item) => item.id === productId);

    if (this.builderArrayLength < this.quantity.max) {
      if (existingProduct) {
        existingProduct.quantity += 1;
        this.builderArrayLength += 1;
      } else {
        this.builderArray.push({
          id: productId,
          quantity: 1,
          sections: this.getSectionsToRender().map((section) => section.id),
        });
        this.builderArrayLength += 1;
      }

      setTimeout(() => {
        productButton.innerHTML = this.content.addToCart;
        this.toggleHideProductsButton(false);
      }, 1000);

      this.createHTMLListElement(product);
      this.maxQuantityTrigger();
    } else {
      this.maxQuantityTrigger();
    }
    this.updateProgressBar(this.builderArrayLength);
  }

  removeFromBuilderArray(buttonElement) {
    const productId = parseInt(buttonElement.dataset.id);
    const existingProductIndex = this.builderArray.findIndex((product) => product.id === productId);

    if (existingProductIndex !== -1) {
      const existingProduct = this.builderArray[existingProductIndex];
      existingProduct.quantity -= 1;
      this.builderArrayLength -= 1;

      if (existingProduct.quantity == 0) {
        this.builderArray.splice(existingProductIndex, 1);
      }
    }

    this.querySelectorAll('.pack-builder__selection-product button').forEach((button) => {
      button.disabled = true;
    });

    buttonElement.closest('.pack-builder__selection-product').remove();

    setTimeout(() => {
      this.querySelectorAll('.pack-builder__selection-product button').forEach((button) => {
        button.disabled = false;
      });
    }, 1000);

    this.maxQuantityTrigger();
    this.updateProgressBar(this.builderArrayLength);
  }

  cartBuilderNotificationTrigger() {
    const initial_state = this.cartBuilderNotification.dataset.textFinal;
    let shouldStop = false;

    this.steps.forEach((step, step_index) => {
      const before = step.dataset.stepTextBefore;
      const between = step.dataset.stepTextBetween;
      const after = step.dataset.stepTextAfter;
      const after_to_next_step = step.dataset.stepTextAfterToNextStep;
      const quantity = parseInt(step.dataset.stepQuantity);

      let step_plus_one;

      this.steps.forEach((step, index) => {
        const step_plus_plus = step_index + 1;
        if (index === step_plus_plus) {
          step_plus_one = parseInt(step.dataset.stepQuantity);
        }
      });

      if (this.builderArrayLength > quantity) {
        this.cartBuilderNotification.innerHTML = initial_state;
        shouldStop = true;
      }

      if (this.builderArrayLength === quantity) {
        this.cartBuilderNotification.innerHTML = `${before} ${quantity} ${between} ${step_plus_one ? step_plus_one - this.builderArrayLength : ''
          } ${after_to_next_step}`;
        shouldStop = true;
      }

      if (this.builderArrayLength < quantity && !shouldStop) {
        this.cartBuilderNotification.innerHTML = `${before} ${this.builderArrayLength} ${between} ${quantity - this.builderArrayLength
          } ${after}
        `;
        shouldStop = true;
      }

      if (shouldStop) {
        return;
      }
    });

    this.dispatchEvent(new CustomEvent('pack-builder:change', { detail: { content: this.cartBuilderNotification.innerHTML } }));
  }

  maxQuantityTrigger() {
    if (this.builderArrayLength >= this.quantity.max) {
      this.products.forEach((product) => {
        const productButton = product.querySelector('.pack-builder__product-atc');
        if (!productButton.getAttribute('disabled')) {
          productButton.setAttribute('disabled', true);
        }
      });
    } else {
      this.products.forEach((product) => {
        const productButton = product.querySelector('.pack-builder__product-atc');
        if (productButton.getAttribute('disabled')) {
          productButton.removeAttribute('disabled');
        }
      });
    }

    this.toggleAddToCartButton();
    this.cartBuilderNotificationTrigger();
  }

  toggleAddToCartButton() {
    if (this.builderArrayLength >= this.quantity.min) {
      this.button.addToCart.removeAttribute('disabled');
      this.button.addToCart.innerHTML = this.button.addToCart.dataset.addToCart;
    } else {
      this.button.addToCart.setAttribute('disabled', true);
      this.button.addToCart.innerHTML = this.content?.addMoreProducts;
    }
  }

  updateProgressBar(nbElements) {
    const nonEmptySteps = this.progressSteps.filter(step => !isNaN(step.reduction) && step.reduction !== 0);

    if (nonEmptySteps.length > 0) {
      const sortedSteps = nonEmptySteps.sort((a, b) => b.quantity - a.quantity);
      const totalMarkers = this.progressMarkerElements.length;

      let closestMarkerIndex = -1;
      for (let i = 0; i < totalMarkers; i++) {
        const markerStep = parseInt(this.progressMarkerElements[i].dataset.step);
        if (nbElements > markerStep) {
          closestMarkerIndex = i;
          break;
        }
      }

      const currentMarker = this.progressMarkerElements[closestMarkerIndex];
      const nextMarker = this.progressMarkerElements[closestMarkerIndex + 1];

      const currentStep = currentMarker ? parseInt(currentMarker.dataset.step) : 0;
      const nextStep = nextMarker ? parseInt(nextMarker.dataset.step) : sortedSteps[sortedSteps.length - 1].quantity;

      const currentLeft = currentMarker ? parseFloat(currentMarker.style.left.replace('%', '')) : 0;
      const nextLeft = nextMarker ? parseFloat(nextMarker.style.left.replace('%', '')) : 100;

      const range = nextLeft - currentLeft;
      const progressInRange = closestMarkerIndex == -1 ? nbElements : nbElements - currentMarker.dataset.step;

      let percentage = currentLeft + (range / (nextStep - currentStep)) * progressInRange;

      if (nbElements >= sortedSteps[0].quantity)
        percentage = 100;

      const percentageValue = parseFloat(percentage);

      if (!isNaN(percentageValue) && isFinite(percentageValue)) {
        this.progressBarElement.style.width = `${percentageValue}%`;
      } else {
        console.error("Invalid percentage value:", percentage);
      }

      this.progressMarkerElements.forEach((marker) => {
        if (marker.dataset.step <= nbElements)
          marker.classList.add('active')
        else
          marker.classList.remove('active')
      })

      this.progressStepsElements.forEach((marker) => {
        if (marker.dataset.step <= nbElements)
          marker.classList.add('active')
        else
          marker.classList.remove('active')
      })

    } else {
      this.progressBarElement.style.width = '0%';
    }
  }
}

customElements.define('pack-builder', PackBuilder);

class PackBuilderStickyBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.listenEvents();
  }

  listenEvents() {
    this.closest('pack-builder').addEventListener('pack-builder:change', (event) => {
      this.updateContent(event.detail.content);
    });
  }

  updateContent(content) {
    this.querySelector('.pack-builder-sticky-bar__content').innerText = content;
    this.classList.contains('hidden') ? this.classList.remove('hidden') : null;
  }
}

customElements.define('pack-builder-sticky-bar', PackBuilderStickyBar);
